'use strict';

module.exports = /*@ngInject*/
function() {
    return {
        restrict: "A",
        link: {
            pre: function(scope, elem, attr) {
                var element = elem;
                var sources;

                // detect browsers with no <video> support
                // Jasmine returns canPlayType as undefined
                if (typeof element[0].canPlayType === 'undefined') {
                    return false;
                }

                function changeSource(sources) {
                    var canPlay;
                    var i = 0;
                    var l = sources.length;

                    for (; i < l; i++) {
                        canPlay = element[0].canPlayType(sources[i].type);

                        if (canPlay === "maybe" || canPlay === "probably") {
                            element.attr("src", sources[i].src);
                            element.attr("type", sources[i].type);
                            break;
                        }
                    }

                    if (canPlay === "") {
                        scope.$emit("onVideoError", {type: "Can't play file"});
                    }
                }

                scope.$watch(attr.angularvideo, function(newValue, oldValue) {
                    if (!sources || newValue !== oldValue) {
                        sources = newValue;
                        changeSource(sources);
                    }
                });
            }
        }
    };
};
